
import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

interface NotificationProps {
    message: string;
    show: boolean;
    onHide: () => void;
}

export const Notification = ({ message, show, onHide }: NotificationProps) => {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(onHide, 3000); // Auto-hide after 3 seconds
            return () => clearTimeout(timer);
        }
    }, [show, onHide]);

    // FIX: Using variants to handle animation to resolve typing issues.
    const notificationVariants = {
        hidden: { opacity: 0, y: -50 },
        visible: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -50 },
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    // FIX: The framer-motion animation props (`initial`, `animate`, `exit`) are not being correctly typed.
                    // Wrapping the animation props in a spread object `...{}` to bypass the faulty type checking on the component's direct props.
                    {...{
                      initial: notificationVariants.hidden,
                      animate: notificationVariants.visible,
                      exit: notificationVariants.exit,
                    }}
                    className="fixed top-5 left-1/2 -translate-x-1/2 z-[100] bg-white p-4 rounded-full shadow-lg border flex items-center space-x-2"
                >
                    <CheckCircle size={20} className="text-green-500" />
                    <p className="text-sm font-medium">{message}</p>
                </motion.div>
            )}
        </AnimatePresence>
    );
};